// frontend/src/components/Login.js

import React, { useContext, useEffect } from 'react';
import GoogleLoginButton from './GoogleLoginButton';
import { AuthContext } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode'; // Corrected Import

const Login = () => {
  const { user, logout } = useContext(AuthContext); // **Destructure 'login' and 'logout'**
  const navigate = useNavigate();


  useEffect(() => {
    if (user) {
      try {
        const decoded = jwtDecode(user.token);
        const currentTime = Date.now() / 1000;
        
        if (decoded.exp < currentTime) {
          logout();
        } else {
          navigate('/app/dashboard'); // Update this line
        }
      } catch (error) {
        console.error('Login: Error decoding token:', error);
        logout();
      }
    }
  }, [user, navigate, logout]);

  // **Optional: Handler for successful login (if needed)**
  // const handleLoginSuccess = (tokens) => {
  //   login(tokens); // **Pass both accessToken and refreshToken**
  // };

  return (
    <div className="flex items-center justify-center h-screen">
      {user ? (
        <h2 className="text-2xl">You are already logged in.</h2>
      ) : (
        <div>
          <h2 className="text-2xl mb-4">Login with Google</h2>
          <GoogleLoginButton /> {/* **Ensure it handles onSuccess correctly** */}
        </div>
      )}
    </div>
  );
};

export default Login;
